(() => {
  const drawer = document.getElementById('dcomReviewDrawer');
  const home = document.getElementById('dcomHome');
  const metadata = document.querySelector('.dcom-product-meta__reviews') || home;
  if (!drawer || !metadata) return;

  const body = drawer.querySelector('.dcom-review-drawer__body');
  const sheet = drawer.querySelector('.dcom-review-drawer__sheet');
  const closeButton = drawer.querySelector('.dcom-review-drawer__close');
  const triggerSelector = '.dcom-product-meta__reviews .junip-product-summary-star-ratings-container, .dcom-home__review-link';
  let borrowedBlock = null;
  let placeholder = null;
  let opener = null;
  let background = [];
  let pageState = null;
  let stopInfiniteScroll = () => {};

  const startInfiniteScroll = () => {
    const sentinel = document.createElement('div');
    sentinel.className = 'dcom-review-drawer__loader';
    sentinel.setAttribute('aria-hidden', 'true');
    const previousBusy = body.getAttribute('aria-busy');
    let active = true;
    let loading = false;
    let loadedCount = 0;
    let frame = 0;
    let timeout = 0;

    const setLoading = value => {
      loading = value;
      sentinel.classList.toggle('is-loading', value);
      body.setAttribute('aria-busy', String(value));
    };

    const stop = () => {
      active = false;
      observer.disconnect();
      body.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      cancelAnimationFrame(frame);
      clearTimeout(timeout);
      body.querySelectorAll('[data-dcom-autoload]').forEach(button => {
        button.removeAttribute('data-dcom-autoload');
      });
      sentinel.remove();
      if (previousBusy === null) body.removeAttribute('aria-busy');
      else body.setAttribute('aria-busy', previousBusy);
    };

    const sync = () => {
      frame = 0;
      if (!active || drawer.hidden) return;
      const count = body.querySelectorAll('.junip-review-list-item-container, .junip-review-grid-item-container').length;
      if (loading && count > loadedCount) {
        clearTimeout(timeout);
        setLoading(false);
      }
      const button = body.querySelector('.junip-see-more');
      if (!button || button.hidden) {
        sentinel.remove();
        return;
      }
      if (!button.hasAttribute('data-dcom-autoload')) button.setAttribute('data-dcom-autoload', '');
      if (sentinel.nextSibling !== button) button.before(sentinel);
      if (loading || button.disabled || button.getAttribute('loading') === 'true' || button.getAttribute('aria-busy') === 'true' || button.getAttribute('aria-disabled') === 'true') return;
      const bounds = body.getBoundingClientRect();
      const position = sentinel.getBoundingClientRect();
      if (position.top > bounds.bottom + 240 || position.bottom < bounds.top) return;
      loadedCount = count;
      setLoading(true);
      timeout = window.setTimeout(stop, 15000);
      button.click();
    };

    const schedule = () => {
      if (active && !frame) frame = requestAnimationFrame(sync);
    };
    const observer = new MutationObserver(schedule);
    observer.observe(body, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['disabled', 'loading', 'aria-busy', 'hidden']
    });
    body.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    schedule();
    return stop;
  };

  const prepareTriggers = () => {
    metadata.querySelectorAll('.junip-product-summary-star-ratings-container, .dcom-home__review-link').forEach(trigger => {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', drawer.id);
      trigger.setAttribute('aria-expanded', String(!drawer.hidden));
    });
  };

  const close = (restoreFocus = true) => {
    if (drawer.hidden) return;
    stopInfiniteScroll();
    if (placeholder?.isConnected && borrowedBlock) placeholder.replaceWith(borrowedBlock);
    drawer.hidden = true;
    background.forEach(([element, wasInert]) => { element.inert = wasInert; });
    background = [];
    document.body.style.overflow = pageState.bodyOverflow;
    document.body.style.paddingRight = pageState.paddingRight;
    document.documentElement.style.overflow = pageState.rootOverflow;
    window.scrollTo({ top: pageState.scrollY, behavior: 'instant' });
    opener?.setAttribute('aria-expanded', 'false');
    if (restoreFocus && opener?.isConnected) opener.focus({ preventScroll: true });
    borrowedBlock = null;
    placeholder = null;
  };

  const open = trigger => {
    if (!drawer.hidden) return true;
    const widget = home
      ? home.querySelector('.dcom-home__reviews .junip-review-section')
      : document.querySelector('.prd-block-info .junip-product-review');
    const block = widget?.closest('.shopify-app-block');
    if (!block) return false;

    opener = trigger;
    pageState = {
      bodyOverflow: document.body.style.overflow,
      rootOverflow: document.documentElement.style.overflow,
      paddingRight: document.body.style.paddingRight,
      scrollY: window.scrollY
    };
    borrowedBlock = block;
    placeholder = document.createComment('DcomDTF review widget position');
    block.before(placeholder);
    body.appendChild(block);
    const heading = widget.querySelector('h2')?.textContent.trim();
    if (heading) drawer.setAttribute('aria-label', heading);

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight) + scrollbarWidth}px`;
    }
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    background = Array.from(document.body.children)
      .filter(element => element !== drawer && !element.matches('.junip-modal') && !['SCRIPT', 'STYLE', 'LINK'].includes(element.tagName))
      .map(element => [element, element.inert]);
    background.forEach(([element]) => { element.inert = true; });
    drawer.hidden = false;
    body.scrollTop = 0;
    trigger.setAttribute('aria-expanded', 'true');
    closeButton.focus({ preventScroll: true });
    stopInfiniteScroll = startInfiniteScroll();
    window.dispatchEvent(new Event('resize'));
    return true;
  };

  document.addEventListener('click', event => {
    const trigger = event.target.closest(triggerSelector);
    if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!open(trigger)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  drawer.querySelectorAll('[data-review-close]').forEach(button => {
    button.addEventListener('click', () => close());
  });
  // Junip owns its review form modal; restore the widget before that modal opens.
  drawer.addEventListener('click', event => {
    if (event.target.closest('.junip-write-review-cta')) close(false);
  }, true);

  document.addEventListener('keydown', event => {
    const trigger = event.target.closest(triggerSelector);
    if (trigger && ['Enter', ' '].includes(event.key) && open(trigger)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (drawer.hidden) return;
    const junipModalOpen = Array.from(document.querySelectorAll('.junip-modal[role="dialog"]'))
      .some(modal => modal.getClientRects().length && getComputedStyle(modal).visibility !== 'hidden');
    if (junipModalOpen) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      close();
    } else if (event.key === 'Tab') {
      const focusable = Array.from(sheet.querySelectorAll(
        'button:not([disabled]), a[href], input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!sheet.contains(document.activeElement) || (event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last)) {
        event.preventDefault();
        (event.shiftKey ? last : first)?.focus();
      }
    }
  }, true);

  prepareTriggers();
  new MutationObserver(prepareTriggers).observe(metadata, { childList: true, subtree: true });
})();
